import { useMatch } from '@tanstack/react-router';

export function useIsInterviewRoute() {
  return (
    useMatch({
      from: '/participants/_authenticated/projects/$projectId/interview',
      shouldThrow: false,
    }) != null
  );
}
